import { Dialog } from "@mui/material";
import DialogContentSelecionarCliente from "../../../../components/DialogContentSelecionarCliente/indext";
import { IDataClientes } from "../../../../types/api/financeiro/pesquisa-clientes";
import { useCallback, useEffect, useState } from "react";
import useMobileScreen from "../../../../lib/useMobileScreen";
import FormSolicitacao from "./FormSolicitacao";
import { FormProvider, useForm } from "react-hook-form";
import { formatarCEP, formatarTelefone } from "../../../../helpers/masks";
import PaperDraggable from "../../../../components/PaperDraggable";
import { clienteDefValue, TProcessoPublicos } from "../../../../types/api/geral/pesquisar-publicos";

export default function SolicitarAnaliseCredito({
    open,
    defaultClienteValue = undefined,
    handleClose,
    onFail,
    handleChangeProcesso
}: SolicitarAnaliseCreditoProps) {

    const telaMobile = useMobileScreen();
 

    const [activeStep, setActiveStep] = useState<number>(0);
    const [modalContent, setModalContent] = useState<TModalContent>("selecionarCliente")

    const methods = useForm({ defaultValues: defaultValuesForm })
    const { getValues, setValue, reset, watch, setError } = methods

    //Funções Manipuladoras
    const handleConfirm = useCallback(() => {
        if (modalContent === "selecionarCliente") {
            setModalContent("criarSolicitacao")
        }
    }, [modalContent])

    const handleBack = useCallback(() => {
        setModalContent("selecionarCliente")
    }, [])

    const handleNextStep = () => {
        const dados = getValues("dadosProp");
        if ((!dados || dados.length === 0) && activeStep === 1) {
            setError("dadosProp", { type: "manual", message: "Adicione pelo menos uma fazenda." });
            return;
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }

    const handleBackStep = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }

    const onCloseModal = () => {
        handleClose()
    }
    //
    const processos: TProcessoPublicos[] = watch('cliente.processo')
    useEffect(() => {
        if (processos) {
            const processoIndex = processos.findIndex(processo => processo.titulo === "Solicitação de Análise de Crédito" && processo.situacao !== 'Finalizado');
            if (processoIndex !== -1) {
                handleChangeProcesso(processos[processoIndex].codigo)
                handleClose()
            }
        }
    }, [processos]);

    useEffect(() => {
        if (defaultClienteValue) {
            setValue("cliente", defaultClienteValue)
            setValue("attCadastral.telefone", formatarTelefone(defaultClienteValue.telefone) ?? "")
            setValue("attCadastral.email", defaultClienteValue.email ?? "")
            setValue("attCadastral.cep", formatarCEP(defaultClienteValue.cep) ?? "")
            setValue("attCadastral.endereco", defaultClienteValue.endereco ?? "")
            setValue("attCadastral.bairro", defaultClienteValue.bairro ?? "")
            setValue("attCadastral.uf", defaultClienteValue.cidade?.estado ?? "")
            setValue("attCadastral.cidade", defaultClienteValue.cidade?.nome ?? "")
            handleConfirm()
        }
    }, [defaultClienteValue])

    return (
        <Dialog
            open={open}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            fullWidth
            fullScreen={telaMobile}
            maxWidth={modalContent === "selecionarCliente" ? "sm" : "md"}
            scroll="body"
        >
            <FormProvider {...methods}>
                {
                    modalContent === "selecionarCliente" &&
                    <DialogContentSelecionarCliente
                        retornarProcessos
                        defaultValue={getValues("cliente")}
                        {...{ handleClose }}
                        onChange={(value: any) => {
                            setValue("cliente", value)
                            setValue("attCadastral.telefone", formatarTelefone(value.telefone) ?? "")
                            setValue("attCadastral.email", value.email ?? "")
                            setValue("attCadastral.cep", formatarCEP(value.cep) ?? "")
                            setValue("attCadastral.endereco", value.endereco ?? "")
                            setValue("attCadastral.bairro", value.bairro ?? "")
                            setValue("attCadastral.uf", value.cidade?.estado ?? "")
                            setValue("attCadastral.cidade", value.cidade?.nome ?? "")
                            handleConfirm()
                        }}
                    />
                }
                {
                    modalContent === "criarSolicitacao" &&
                    <FormSolicitacao
                        {...{ handleChangeProcesso }}
                        onBack={() => {
                            setActiveStep(0)
                            handleBack()
                        }}
                        handleNext={handleNextStep}
                        handleBack={handleBackStep}
                        handleClose={() => onCloseModal()}
                        onCreate={() => {
                            reset()
                            setActiveStep(0)
                            setModalContent("selecionarCliente")
                            handleClose()
                        }}
                        onCleanForm={() => {
                            setActiveStep(0)
                            setModalContent("selecionarCliente")
                        }}
                        {...{ onFail, modalContent, activeStep }}
                    />
                }
            </FormProvider>
        </Dialog>
    )
}

export const defaultValuesForm = {
    cliente: clienteDefValue,
    attCadastral: {
        possuiConjuge: "Sim",
        conjuge: "",
        document: "",
        telefone: "",
        email: "",
        cep: "",
        endereco: "",
        numero: "",
        complemento: "",
        bairro: "",
        uf: "MG",
        cidade: ""
    },
    dadosProp: [],
    dadosSolicitacao: {
        valor: "",
        prazo: "",
        observacoes: ""
    },
    enviarAnexos: {
        docIdentidade: null,
        comprovanteEnd: null,
        certidaoCasamento: null,
        documentoIdConjuge: null,
        cartaoProdutorRural: null,
        docPropriedade: null,
        declaracaoIRPF: null,
        itr: null,
        ccir: null,
        car: null
    }
}

interface SolicitarAnaliseCreditoProps {
    open: boolean,
    defaultClienteValue?: any,
    handleClose: () => void,
    onCreate: (codigo: string) => void
    onFail: () => void,
    handleChangeProcesso: (item: string) => void
}

export type TModalContent = "selecionarCliente" | "criarSolicitacao"

interface IValue {
    cliente: IDataClientes,
}